// React
import React from 'react';

// Assets
import { ExclamationCircleFilled, PhoneFilled } from '@ant-design/icons';

// Packages
import { Button, CircularProgress, Stack, Typography } from '@mui/material';

const pillSx = {
    minWidth: 120,
    px: 3,
    borderRadius: '26.5px',
    fontSize: '0.9375rem',
    '&:active::after': { borderRadius: '26.5px' }
};

// Shown on the dark call stage while a call is set up (token, microphone) or when that
// fails. End is always offered, so the operator is never stuck on a call with no way out.
const CallStageStatus = ({ title, message, error, onRetry, onEnd }) => (
    <Stack
        spacing={2.5}
        alignItems="center"
        justifyContent="center"
        sx={{
            width: '100%',
            height: '100%',
            px: 3,
            borderRadius: 3,
            bgcolor: 'rgb(32, 32, 32)',
            color: '#ffffff',
            textAlign: 'center'
        }}
    >
        {title && (
            <Typography variant="h4" color="inherit" sx={{ fontWeight: 600 }}>
                {title}
            </Typography>
        )}
        <Stack direction="row" spacing={1.25} alignItems="center">
            {error ? (
                <ExclamationCircleFilled style={{ fontSize: 18, color: '#FAAD14' }} />
            ) : (
                <CircularProgress size={18} thickness={5} sx={{ color: '#62D08A' }} />
            )}
            <Typography variant="body1" sx={{ color: 'rgba(255, 255, 255, 0.72)' }}>
                {message}
            </Typography>
        </Stack>
        <Stack direction="row" spacing={1.5}>
            {error && onRetry && (
                <Button
                    variant="outlined"
                    onClick={onRetry}
                    sx={{
                        ...pillSx,
                        color: '#ffffff',
                        borderColor: 'rgba(255, 255, 255, 0.4)',
                        '&:hover': {
                            borderColor: '#ffffff',
                            bgcolor: 'rgba(255, 255, 255, 0.08)'
                        }
                    }}
                >
                    Retry
                </Button>
            )}
            <Button
                variant="contained"
                color="error"
                onClick={onEnd}
                startIcon={<PhoneFilled style={{ transform: 'rotate(225deg)' }} />}
                sx={pillSx}
            >
                End Call
            </Button>
        </Stack>
    </Stack>
);

export default CallStageStatus;
